function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15 2.5C8.1125 2.5 2.5 8.1 2.5 15C2.5 21.8875 8.1125 27.5 15 27.5C21.9 27.5 27.5 21.8875 27.5 15C27.5 8.21695 22.0882 2.6902 15.3497 2.50481L15 2.5Z",
  fill: "url(#mobile_help)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9999 21H15.9998V19.0075H13.9999V21Z",
  fill: "#F5FAFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.9999 18.0113H15.9998C16.0846 17.0477 16.6175 16.1794 17.4398 15.6651C18.3494 15.0826 18.9281 14.105 18.9997 13.0301C19.0158 11.6064 18.2683 10.2823 17.0388 9.55655C15.8093 8.83084 14.2845 8.81375 13.0389 9.51172C11.7933 10.2097 11.0161 11.5167 11 12.9404V13.0301H12.9999C12.9999 11.9296 13.8953 11.0376 14.9999 11.0376C16.1044 11.0376 16.9998 11.9296 16.9998 13.0301C16.9998 13.9058 16.4311 14.3401 15.7721 14.8435L15.7698 14.8452C14.646 15.5015 13.9683 16.7138 13.9999 18.0113Z",
  fill: "#F5FAFF"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "mobile_help",
  x1: 15,
  y1: 2.5,
  x2: 15,
  y2: 27.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0078FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00ACFF"
})));

function SvgGroupHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupHelp);
export default __webpack_public_path__ + "static/media/GroupHelp.7c2a3672.svg";
export { ForwardRef as ReactComponent };